<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='30%' class=""></div>
                    <div class="bold white center">KD ’000</div>
                </div>
                <div class="trow lGray">
                    <div data-width='55%'></div>
                    <div data-width='15%' class='white font b-right'>Land and
                        <br /> building</div>
                    <div data-width='15%' class="white font b-right">Cellular and other
                        <br />equipment</div>
                    <div data-width='15%' class="white font end">Total</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='55%' class='font'>Balance as of 1 January 2019</div>
                    <div data-width='15%' class='font'>163,924</div>
                    <div data-width='15%' class="font">29,852</div>
                    <div data-width='15%' class="font end">193,776</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Add: Additions</div>
                    <div data-width='15%' class='font'> 51,488</div>
                    <div data-width='15%' class="font">1,189</div>
                    <div data-width='15%' class="font end">52,677</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Less: Amortisation</div>
                    <div data-width='15%' class='font'>(42,312)</div>
                    <div data-width='15%' class="font">(8,525)</div>
                    <div data-width='15%' class="font end">(50,837)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Less: Retirement</div>
                    <div data-width='15%' class='font'>(4,266)</div>
                    <div data-width='15%' class="font">(10,042)</div>
                    <div data-width='15%' class="font end">(14,308)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Exchange adjustments</div>
                    <div data-width='15%' class='font'>(175)</div>
                    <div data-width='15%' class="font">(81) </div>
                    <div data-width='15%' class="font end">(256)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>Closing balance as at 31 December 2019 (excluding assets of
                        <br />disposal group classified as held for sale)</div>
                    <div data-width='15%' class='font'>168,659</div>
                    <div data-width='15%' class="font">12,393</div>
                    <div data-width='15%' class="font end">181,052</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='30%' class=""></div>
                    <div class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow lGray">
                    <div data-width='55%'></div>
                    <div data-width='15%' class='white font b-right'>أرض
                        <br />ومبنى</div>
                    <div data-width='15%' class="white font b-right">أجهزة هاتف 
                        <br />خلوي وأخرى</div>
                    <div data-width='15%' class="white font end">المجموع</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='55%' class='font'>الرصيد كما في 1 يناير 2019</div>
                    <div data-width='15%' class='font'>163,924</div>
                    <div data-width='15%' class="font">29,852</div>
                    <div data-width='15%' class="font end">193,776</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>يضاف: إضافات</div>
                    <div data-width='15%' class='font'> 51,488</div>
                    <div data-width='15%' class="font">1,189</div>
                    <div data-width='15%' class="font end">52,677</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>ناقصًا: إطفاءات</div>
                    <div data-width='15%' class='font'>(42,312)</div>
                    <div data-width='15%' class="font">(8,525)</div>
                    <div data-width='15%' class="font end">(50,837)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>ناقصًا: الاستبعاد</div>
                    <div data-width='15%' class='font'>(4,266)</div>
                    <div data-width='15%' class="font">(10,042)</div>
                    <div data-width='15%' class="font end">(14,308)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>تعديلات صرف عملات أجنبية</div>
                    <div data-width='15%' class='font'>(175)</div>
                    <div data-width='15%' class="font">(81) </div>
                    <div data-width='15%' class="font end">(256)</div>
                </div>
                <div class="trow ">
                    <div data-width='55%' class='font'>الرصيد الختامي كما في 31 ديسمبر 2019 (باستثناء موجودات مجموعة 
                        <br />الاستبعاد المصنفة كمحتفظ بها لغرض البيع)</div>
                    <div data-width='15%' class='font'>168,659</div>
                    <div data-width='15%' class="font">12,393</div>
                    <div data-width='15%' class="font end">181,052</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>